import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  boMembers: [],
  boMembersUiMeta: [],
  boMember: {},
})

// getters
const getters = {}

// actions
const actions = {
  listBoMembers({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListBoMembers{
            created_at
            invisible_id
            modules
            updated_at
            username
          }
        }
      `,
      variables: {
        name: 'BoMemberListVo',
      }
    }).then(data => {
      commit('set', ['boMembersUiMeta', data.GetUiMeta])
      commit('setBoMembers', data.ListBoMembers)
      return true
    })
  },
  getBoMember({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetBoMember(id: $id){
            created_at
            id
            modules
            roles
            updated_at
            username
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setBoMember', resp.GetBoMember)
      return true
    })
  },
  updateBoMember(_, boMember) {
    return gqlApi.query({
      query: `    
        mutation($input: BoMemberUpdateVo){
          UpdateBoMember(input: $input){
            id
          }
        }
      `,
      variables: {
        input: boMember,
      },
    }).then(() => {
      return true
    })
  },
  addBoMember(_, boMember) {
    return gqlApi.query({
      query: `    
        mutation($input: BoMemberAddVo){
          AddBoMember(input: $input){
            id
          }
        }
      `,
      variables: {
        input: boMember,
      },
    }).then(() => {
      return true
    })
  },
  deleteBoMember(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteBoMember(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
}

// mutations_
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setBoMembers (state, boMembers) {
    state.boMembers = boMembers
  },
  setBoMember (state, boMember) {
    state.boMember = boMember
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}